import { alias } from '@ember/object/computed';

import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

export default class MlpModuleModel extends Model {
  @attr('string') headline;

  // Relation
  @belongsTo('content-item', {
    as: 'mlp-module',
    async: false,
    inverse: 'entity',
  })
  contentItem;

  // Getter, setter and computed properties
  @alias('headline') displayHeadline;
  @alias('headline') displayLabel;

  isMlpModule = true;

  get cmsModified() {
    return this.contentItem?.cmsModified;
  }
}
